import { Injectable } from '@angular/core';
import { from, map, mergeMap, OperatorFunction } from 'rxjs';

import { User, UserCredential } from 'firebase/auth';
import { CapacitorEventBird } from 'capacitor-event-bird';

import { FirebaseAuthService } from '../services';

export interface GoogleAuthResult {
  data: UserCredential;
  token: string;
}

@Injectable()
export class GoogleAuthHelperService {
  constructor(private readonly firebaseAuthService: FirebaseAuthService) {}

  authenticateWithGoogle(): OperatorFunction<boolean, GoogleAuthResult> {
    return mergeMap((isNative) => {
      if (isNative) {
        return from(CapacitorEventBird.signupWithGoogle())
          .pipe(map((data) => {
            if (!data?.firebaseToken || !data.email || !data.displayName) {
              throw new Error('Google Sign-In failed: could not retrieve authentication token. Please try again.');
            }

            return {
              data: {
                user: {
                  displayName: data.displayName,
                  email: data.email,
                } as User,
                providerId: 'google.com',
                operationType: 'signIn',
              } as UserCredential,
              token: data.firebaseToken,
            };
          }));
      }

      return this.firebaseAuthService.authenticateByGoogle();
    });
  }
}
